import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Siren, HeartPulse, Flame, Lock, Ambulance } from 'lucide-react';
import { siteData } from '../data.js';
import SEO from '../components/SEO.jsx';
import { useCmsCollection } from '../lib/cms.js';

const icons = {
  Shield: Shield,
  Siren: Siren,
  HeartPulse: HeartPulse,
  Flame: Flame,
  Lock: Lock,
  Ambulance: Ambulance
};

export default function WhoWeHelp() {
  const { data: rawGroups } = useCmsCollection('hvem_hjaelper_vi', siteData.whoWeHelp || []);

  const groupsList = rawGroups.map((g) => {
    const d = g.data || g;
    return {
      name: d.navn || d.name,
      icon: d.ikon || d.icon,
      description: d.beskrivelse || d.description,
    };
  });
  return (
    <div className="pt-32 pb-24">
      <SEO
        title="Hvem hjælper vi? | Forsvar, politi, sundhed, brand og redning"
        description="TFDI favner alle faggrupper i frontlinjen: Forsvar, Politi, Sygehus & Sundhed, Fængselsvæsen, Brand & Redning samt Ambulance. Vi sikrer støtte og rådgivning."
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-20 text-center mx-auto mt-8 not-italic">
          <h1 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-8">Hvem hjælper vi?</h1>
          <p className="text-xl text-slate-600 leading-relaxed">
            Vi favner alle dem, der står i forreste linje for Danmark. Uanset uniform eller ansættelsessted, så yder vi det sikkerhedsnet, der kan mangle.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 not-italic">
          {groupsList.map((group, idx) => {
            const Icon = icons[group.icon] || Shield;
            return (
              <div key={idx} className="p-5 md:p-10 bg-white border border-slate-100 rounded-[2.5rem] shadow-sm">
                <div className="w-12 h-12 md:w-16 md:h-16 bg-red-50 text-red-600 rounded-2xl flex items-center justify-center mb-8">
                  <Icon className="w-6 h-6 md:w-8 md:h-8" />
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-4">{group.name}</h3>
                <p className="text-slate-600 leading-relaxed mb-6">
                  Vi hjælper med alt fra rådgivning omkring PTSD til juridisk bistand ved arbejdsskadesager inden for {group.name.toLowerCase()}.
                </p>
                <div className="h-1.5 w-12 bg-red-600 rounded-full" />
              </div>
            );
          })}
        </div>

        <div className="mt-24 p-5 md:p-20 bg-slate-900 rounded-[3rem] text-white overflow-hidden relative">
          <div className="absolute top-0 right-0 w-96 h-96 bg-red-600/10 rounded-full -mr-48 -mt-48 blur-3xl" />
          <div className="relative z-10 max-w-2xl not-italic">
            <h2 className="text-3xl font-bold mb-8">Er din gruppe ikke på listen?</h2>
            <p className="text-lg text-slate-400 mb-10 leading-relaxed">
              Definitionen af "frontpersonale" er bred. Hvis du føler, at din indsats for samfundet har været særlig, og du står i en svær situation pga. dit arbejde, så ræk ud til os alligevel. Vi vurderer alle henvendelser individuelt.
            </p>
            <Link to="/kontakt" className="inline-flex items-center gap-2 text-red-500 font-bold text-lg hover:text-red-400 transition-colors group">
              Kontakt os for en vurdering <Shield size={20} className="group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
